import { RootState } from '../reducers'
import { initialTideState } from './reducer'

export const tideSelector = (state: RootState) => (state.tide.tide ? state.tide.tide : initialTideState.tide)
